<template>
  <div class="f">
    <div class="login" v-if="loginFlag">
      <div class="login1">
        <p @click="loginFlag = true">{{ $t("info.lang.login") }}</p>
        <p
          @click="
            loginFlag = false;
            psw = '';
          "
        >
          {{ $t("info.lang.register") }}
        </p>
      </div>

      <div class="msg">
        <h3>{{ $t("info.lang.account") }}</h3>
        <input v-model="account" />

        <h3>{{ $t("info.lang.password") }}</h3>
        <input type="password" v-model="psw" />
      </div>

      <img class="btn" src="../assets/newImg/mobile/btn.png" @click="login" />
    </div>

    <div class="register" v-else>
      <div class="login1">
        <p
          @click="
            loginFlag = true;
            psw = '';
          "
        >
          {{ $t("info.lang.login") }}
        </p>
        <p @click="loginFlag = false">{{ $t("info.lang.register") }}</p>
      </div>
      <div class="msg">
        <h3>{{ $t("info.lang.nickname") }}</h3>
        <input v-model="nickname" />
        <h3>{{ $t("info.lang.account") }}</h3>
        <input v-model="account" />

        <h3>{{ $t("info.lang.password") }}</h3>
        <input type="password" v-model="psw" />
      </div>
      <img class="btn" src="../assets/newImg/mobile/btn.png" @click="register" />
    </div>
  </div>
</template>

<script>
import { register, login } from "../assets/api/index";
import md5 from "js-md5";
export default {
  data() {
    return {
      loginFlag: true,
      account: "",
      psw: "",
      nickname: "",
    };
  },
  methods: {
    login() {
      console.log(this.account);
      if (!this.account || !this.psw) {
        this.$message.error(this.$t("info.lang.loginError1"));
      } else {
        login({
          acount: this.account,
          psd: md5(this.psw),
        }).then((res) => {
          if (res.auth > 4) {
            this.$message.error("管理员请使用pc登录");
            return;
          }
          if (res.code != 1) {
            this.$message({
              message: this.$t("info.lang.loginSuccess"),
              type: "success",
            });
            var obj = {
              acount: this.account,
              psd: md5(this.psw),
            };
            localStorage.setItem("info", JSON.stringify(obj));

            this.$router.push({ name: "mobileIndex" });
          } else {
            this.$message.error(res.error);
          }
        });
      }
    },
    register() {
      let reg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
      var reg1 = /^[\u4E00-\u9FA5A-Za-z0-9_]+$/;
      var reg2 = /\w[-\w.+]*@([A-Za-z0-9][-A-Za-z0-9]+\.)+[A-Za-z]{2,14}/;
      if (!this.account || !this.psw) {
        this.$message.error(this.$t("info.lang.loginError1"));
      } else if (!reg.test(this.account) && !reg2.test(this.account)) {
        this.$message.error(this.$t("info.lang.loginError5"));
      } else if (!reg1.test(this.nickname)) {
        this.$message.error("昵称不能包含特殊符号");
      } else {
        register({
          name: this.nickname,
          acount: this.account,
          psd: md5(this.psw),
        }).then((res) => {
          if (res.code == 0) {
            this.loginFlag = true;
            this.$message({
              message: res.info,
              type: "success",
            });
          } else {
            this.$message.error(res.info);
          }
        });
      }
    },
  },

  created() {},
  beforeCreate() {
    if (localStorage.getItem("info")) {
      this.$router.push({ name: "mobileIndex" });
    }
  },
  mounted() {
    this.$confirm("全屏浏览此网页将获得更好的体验,是否切换到全屏浏览?", "提示", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "success",
    })
      .then(() => {
        var element = document.documentElement;
        if (element.requestFullScreen) {
          element.requestFullScreen();
        } else if (element.webkitRequestFullScreen) {
          element.webkitRequestFullScreen();
        } else if (element.mozRequestFullScreen) {
          element.mozRequestFullScreen();
        } else if (element.msRequestFullScreen) {
          element.msRequestFullScreen();
        } else {
          this.$message.error("当前浏览器不支持全屏");
        }
      })
      .catch(() => {
        this.$message({
          type: "info",
          message: "已取消",
        });
      });
  },
};
</script>

<style lang="scss" scoped>
.f {
  width: 100%;
  height: 100%;
  background: url("../assets/newImg/banner.jpg");
  background-size: 100% 100%;
  font-size: 16px;

  font-weight: 400;
  overflow: hidden;
  color: #ffffff;

  .login,
  .register {
    transform: scale(0.8);
    width: 466px;
    height: 293px;
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    margin: auto;
    background-image: url("../assets/newImg/mobile/login.png");

    text-align: center;

    .login1 {
      height: 55px;
      line-height: 55px;
      p {
        width: 50%;
        height: 100%;
        display: inline-block;
      }
    }
    .msg {
      width: 336px;
      margin-top: 48px;
      display: inline-block;
      h3 {
        font-size: 16px;
        text-align: left;
        font-weight: 400;
        margin-bottom: 13px;
      }
      input {
        width: 100%;
        color: #ffffff;
        background: transparent;
        border: 0;
        border-bottom: 1px solid white;
        margin-bottom: 30px;
      }
    }
    .btn {
      position: absolute;
      top: 0;
      bottom: 0;
      margin: auto;
      right: -75px;
    }
  }

  .register {
    background-image: url("../assets/newImg/mobile/register.png");

    .msg {
      margin-top: 29px;
      h3 {
        margin-bottom: 6px;
      }
      input {
        margin-bottom: 12px;
      }
    }
  }
}
</style>
